const TitleBetween = ({ title }) => {
  return <div className="text-5xl font-bold py-4 pl-5">{title}</div>;
};

export default TitleBetween;
